<div class="modal fade items-modal"
     [class.show]="visible"
     [style.display]="visible ? 'block' : 'none'"
     tabindex="-1"
     *ngIf="visible"
     (click)="close()">

  <div class="modal-dialog modal-xl modal-dialog-centered" (click)="$event.stopPropagation()">
    <div class="modal-content">

      <div class="modal-header">
        <div class="d-flex flex-column">
          <h5 class="modal-title d-flex align-items-center gap-2">
            <i class="fas fa-boxes text-primary"></i>
            Colli Borderò
            <span class="text-muted small" *ngIf="loadingList?.loadingListCode">
              ({{ loadingList?.loadingListCode }})
            </span>
          </h5>

          <div class="modal-subtitle">
            <span class="badge bg-light text-muted me-2">
              Totale: {{ getTotalCount() }}
            </span>
            <span class="badge bg-light text-muted">
              Sparati: {{ getShotCount() }}
            </span>
          </div>
        </div>

        <button type="button" class="btn-close" (click)="close()"></button>
      </div>

      <div class="modal-body">

        <div class="text-center py-4" *ngIf="isLoading">
          <div class="spinner-border text-primary" role="status"></div>
          <div class="text-muted mt-2">Caricamento colli...</div>
        </div>

        <ng-container *ngIf="!isLoading">

          <div class="filters-row">
            <div class="filter-block">
              <label class="form-label small">Ricerca</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-search filter-icon"></i>
                <input type="text"
                       class="filter-input"
                       [(ngModel)]="searchTerm"
                       (input)="applyFilters()"
                       placeholder="ParcelId, status, createdBy...">
              </div>
            </div>

            <div class="filter-block">
              <label class="form-label small">Status</label>
              <div class="filter-input-wrapper">
                <i class="fas fa-flag filter-icon"></i>
                <select class="filter-select"
                        [(ngModel)]="filterStatus"
                        (change)="applyFilters()">
                  <option value="">Tutti</option>
                  <option *ngFor="let s of availableStatuses" [value]="s">{{ s }}</option>
                </select>
              </div>
            </div>

            <div class="filter-actions">
              <button class="btn btn-outline-secondary btn-sm" (click)="resetFilters()">
                <i class="fas fa-undo me-1"></i>
                Reset
              </button>

              <button type="button"
                      class="header-action-btn"
                      (click)="printSelected()"
                      [disabled]="selectedIds.size === 0 || isPrinting"
                      title="Stampa selezionati">
                <i class="fas text-danger"
                   [class.fa-file-pdf]="!isPrinting"
                   [class.fa-spinner]="isPrinting"
                   [class.fa-spin]="isPrinting"></i>
              </button>

              <button type="button"
                      class="header-action-btn"
                      (click)="exportSelected()"
                      [disabled]="selectedIds.size === 0 || isExporting"
                      title="Esporta selezionati">
                <i class="fas text-success"
                   [class.fa-download]="!isExporting"
                   [class.fa-spinner]="isExporting"
                   [class.fa-spin]="isExporting"></i>
              </button>

              <span class="badge bg-light text-muted">
                Filtrati: {{ filteredItems.length }} |
                Sparati: {{ getShotCountFiltered() }}
              </span>
            </div>
          </div>

          <div class="table-card">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead class="table-light">
                  <tr>
                    <th style="width:40px" class="text-center">
                      <input type="checkbox"
                             class="form-check-input"
                             [checked]="areAllSelected()"
                             (change)="areAllSelected() ? deselectAll() : selectAll()">
                    </th>
                    <th style="width:60px">#</th>
                    <th>ID Item</th>
                    <th>Parcel ID</th>
                    <th class="text-center">Status</th>
                    <th class="d-none d-lg-table-cell">Creato il</th>
                    <th class="d-none d-lg-table-cell">Creato da</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let it of pagedItems; let i = index; trackBy: trackByItemId">
                    <td class="text-center">
                      <input type="checkbox"
                             class="form-check-input"
                             [checked]="isSelected(it.loadingListItemId)"
                             (change)="toggleSelection(it.loadingListItemId)">
                    </td>

                    <td class="text-muted">
                      {{ (currentPage - 1) * itemsPerPage + i + 1 }}
                    </td>

                    <td class="fw-medium">{{ it.loadingListItemId }}</td>

                    <td><span class="font-monospace">{{ it.loadingListItemParcelId }}</span></td>

                    <td class="text-center">
                      <span class="badge" [ngStyle]="getItemStatusStyle(it.loadingListItemStatus)">
                        {{ it.loadingListItemStatus || 'UNKNOWN' }}
                      </span>
                    </td>

                    <td class="d-none d-lg-table-cell">
                      <span *ngIf="it.loadingListItemCreatedAt; else noDate">
                        {{ it.loadingListItemCreatedAt | date:'dd/MM/yy HH:mm' }}
                      </span>
                      <ng-template #noDate><span class="text-muted">-</span></ng-template>
                    </td>

                    <td class="d-none d-lg-table-cell">{{ it.loadingListItemCreatedBy || '-' }}</td>
                  </tr>

                  <tr *ngIf="filteredItems.length === 0">
                    <td colspan="7" class="text-center py-4 text-muted">
                      <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
                      Nessun collo trovato
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="pagination-bar">
              <div class="btn-group btn-group-sm">
                <button class="btn"
                        [ngClass]="itemsPerPage === 10 ? 'btn-secondary' : 'btn-outline-secondary'"
                        (click)="setItemsPerPage(10)">10</button>
                <button class="btn"
                        [ngClass]="itemsPerPage === 25 ? 'btn-secondary' : 'btn-outline-secondary'"
                        (click)="setItemsPerPage(25)">25</button>
                <button class="btn"
                        [ngClass]="itemsPerPage === 50 ? 'btn-secondary' : 'btn-outline-secondary'"
                        (click)="setItemsPerPage(50)">50</button>
                <button class="btn"
                        [ngClass]="itemsPerPage === 100 ? 'btn-secondary' : 'btn-outline-secondary'"
                        (click)="setItemsPerPage(100)">100</button>
              </div>

              <div class="pager">
                <button class="pagination-btn"
                        (click)="onPageChange(currentPage - 1)"
                        [disabled]="currentPage === 1">
                  <i class="fas fa-chevron-left"></i>
                </button>

                <span class="page-info">
                  Pagina {{ currentPage }} / {{ getTotalPages() }}
                </span>

                <button class="pagination-btn"
                        (click)="onPageChange(currentPage + 1)"
                        [disabled]="currentPage === getTotalPages()">
                  <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>

        </ng-container>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">
          <i class="fas fa-times me-1"></i>
          Chiudi
        </button>
      </div>

    </div>
  </div>
</div>

<div class="modal-backdrop fade" [class.show]="visible" *ngIf="visible"></div>
